var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-box"},[_c('el-image',{style:({width: _vm.cWidth, height: _vm.cHeight, 'line-height': _vm.cHeight}),attrs:{"src":_vm.previewUrl,"preview-src-list":_vm.previewList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }